/**
 * custom-product.js  |  assets/
 */
(function () {
  'use strict';

  const PRODUCT = window.CP && window.CP.product;
  if (!PRODUCT) return;

  // ─── State ──────────────────────────────────────────────
  let selectedVariant = null;
  let selectedColor   = null;
  let noColorOption   = false;

  // ─── DOM ────────────────────────────────────────────────
  const $  = id  => document.getElementById(id);
  const $$ = sel => [...document.querySelectorAll(sel)];

  // ─── Drawer helpers ─────────────────────────────────────
  function openDrawer(id) {
    const el = $(id); if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(id) {
    const el = $(id); if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ─── Money ──────────────────────────────────────────────
  function moneyFormat(cents) {
    return '$ ' + (cents / 100).toFixed(2) + ' USD';
  }

  // ─── Option indexes ─────────────────────────────────────
  function getOptionIndex(name) {
    return PRODUCT.options.findIndex(o => o.toLowerCase() === name.toLowerCase());
  }
  const colorIdx = getOptionIndex('Color');
  const sizeIdx  = getOptionIndex('Size');
  if (colorIdx === -1) noColorOption = true;

  // ─── Unique first-variant per color ─────────────────────
  function getUniqueColors() {
    if (noColorOption) return [];
    const seen = new Set();
    return PRODUCT.variants.filter(v => {
      const c = v.options[colorIdx];
      if (seen.has(c)) return false;
      seen.add(c); return true;
    });
  }

  // ─── Variant image src ───────────────────────────────────
  function getVariantImage(variant) {
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return PRODUCT.images.length ? PRODUCT.images[0].src : '';
  }

  // ─── Shopify CDN resize ──────────────────────────────────
  function resizeImg(src, size) {
    if (!src) return '';
    // Handle both v=... and no query string
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, `_${size}x$1$3`);
  }

  // ════════════════════════════════════════════════════════
  // COLOR SWATCH — accurate CSS color mapping
  // ════════════════════════════════════════════════════════
  const COLOR_MAP = {
    // Blacks & whites
    'black':        '#0a0a0a',
    'white':        '#ffffff',
    'off white':    '#f5f2eb',
    'cream':        '#f5f0e0',
    'ivory':        '#fffff0',
    'ecru':         '#c2b280',
    // Grays
    'grey':         '#808080',
    'gray':         '#808080',
    'light grey':   '#d3d3d3',
    'light gray':   '#d3d3d3',
    'dark grey':    '#404040',
    'dark gray':    '#404040',
    'charcoal':     '#36454f',
    'slate':        '#708090',
    'silver':       '#c0c0c0',
    // Blues
    'blue':         '#4a6fa5',
    'navy':         '#001f5b',
    'navy blue':    '#001f5b',
    'dark blue':    '#00008b',
    'light blue':   '#add8e6',
    'sky blue':     '#87ceeb',
    'cobalt':       '#0047ab',
    'royal blue':   '#4169e1',
    'denim':        '#1560bd',
    'indigo':       '#4b0082',
    'teal':         '#008080',
    'turquoise':    '#40e0d0',
    'aqua':         '#00ffff',
    'midnight':     '#191970',
    'midnight blue':'#191970',
    // Greens
    'green':        '#3a7d44',
    'olive':        '#808000',
    'olive green':  '#6b6914',
    'dark green':   '#006400',
    'forest green': '#228b22',
    'sage':         '#b2ac88',
    'sage green':   '#77815c',
    'mint':         '#98ff98',
    'khaki':        '#c3b091',
    'army green':   '#4b5320',
    'moss':         '#8a9a5b',
    'hunter green': '#355e3b',
    'gray green':   '#8fbc8f',
    'grey green':   '#8fbc8f',
    // Reds & pinks
    'red':          '#c0392b',
    'dark red':     '#8b0000',
    'burgundy':     '#800020',
    'wine':         '#722f37',
    'maroon':       '#800000',
    'crimson':      '#dc143c',
    'scarlet':      '#ff2400',
    'pink':         '#ffb6c1',
    'hot pink':     '#ff69b4',
    'rose':         '#ff007f',
    'blush':        '#de5d83',
    'dusty rose':   '#dcae96',
    'mauve':        '#e0b0ff',
    'coral':        '#ff6b6b',
    'salmon':       '#fa8072',
    'peach':        '#ffcba4',
    'dusty peach':  '#e8b4a0',
    // Oranges & yellows
    'orange':       '#e67e22',
    'burnt orange': '#cc5500',
    'amber':        '#ffbf00',
    'yellow':       '#f1c40f',
    'mustard':      '#e1ad01',
    'gold':         '#ffd700',
    'tan':          '#d2b48c',
    'camel':        '#c19a6b',
    'sand':         '#c2b280',
    'beige':        '#f5f5dc',
    'nude':         '#e3bc9a',
    // Purples
    'purple':       '#8e44ad',
    'violet':       '#ee82ee',
    'lavender':     '#e6e6fa',
    'lilac':        '#c8a2c8',
    'plum':         '#dda0dd',
    // Browns
    'brown':        '#795548',
    'chocolate':    '#7b3f00',
    'mocha':        '#967969',
    'coffee':       '#6f4e37',
    'rust':         '#b7410e',
    'terracotta':   '#e2725b',
    'brick':        '#cb4154',
    // Metals
    'bronze':       '#cd7f32',
    'copper':       '#b87333',
    'rose gold':    '#b76e79',
    'champagne':    '#f7e7ce',
    // Special
    'multi':        'linear-gradient(135deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff)',
    'multicolor':   'linear-gradient(135deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff)',
    'print':        'linear-gradient(135deg,#ddd 25%,#aaa 25%,#aaa 50%,#ddd 50%,#ddd 75%,#aaa 75%)',
    'stripe':       'repeating-linear-gradient(90deg,#333 0,#333 4px,#fff 4px,#fff 8px)',
  };

  function getSwatchColor(colorName) {

    const key = (colorName || '').trim();

    console.log('COLOR:', key);
    console.log('META:', window.CP.swatchColors?.[key]);
    console.log('MAP:', COLOR_MAP[key.toLowerCase()]);

    return window.CP.swatchColors?.[key] || COLOR_MAP[key.toLowerCase()] || null;
}

  function setSwatchEl(el, colorName) {
    if (!el) return;
    const color = getSwatchColor(colorName);
    if (color) {
      if (color.startsWith('linear-gradient') || color.startsWith('repeating')) {
        el.style.background = color;
      } else {
        el.style.backgroundColor = color;
      }
      // Dark border on light colors
      const isLight = ['#ffffff','#f5f2eb','#fffff0','#f5f0e0','#f5f5dc','#e6e6fa','#ffb6c1','#add8e6','#d3d3d3','#c0c0c0','#fff','#f5f5f5'].includes(color.toLowerCase());
      el.style.border = isLight ? '1px solid rgba(0,0,0,0.25)' : '1px solid transparent';
    } else {
      // Fallback: no color found, show neutral
      el.style.backgroundColor = '#ccc';
      el.style.border = '1px solid rgba(0,0,0,0.15)';
    }
  }

  // ════════════════════════════════════════════════════════
  // GALLERY
  // ════════════════════════════════════════════════════════
  function initGallery() {
    const track  = $('cpGalleryTrack');
    const dots   = $$('.cp-gallery__dot');
    const slides = $$('.cp-gallery__slide');
    if (!track || !slides.length) return;

    let currentIdx = 0;
    function setActive(idx) {
      dots.forEach((d, i) => d.classList.toggle('active', i === idx));
      currentIdx = idx;
    }

    const isMobile = () => window.innerWidth <= 768;

    track.addEventListener('scroll', () => {
      const idx = isMobile()
        ? Math.round(track.scrollLeft / track.clientWidth)
        : Math.round(track.scrollTop / track.clientHeight);
      setActive(idx);
    }, { passive: true });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index);
        isMobile()
          ? track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' })
          : track.scrollTo({ top: idx * track.clientHeight, behavior: 'smooth' });
      });
    });

    window.cpFilterGallery = function () {
      const color = (selectedColor || '').trim().toLowerCase();

      const getMediaColor = (slide) => {
        let mediaColor = (slide.dataset.color || '').trim().toLowerCase();

        // Video fallback: aria-label se alt lo
        if (!mediaColor && slide.dataset.mediaType === 'video') {
          mediaColor = (
            slide.querySelector('video')?.getAttribute('aria-label') || ''
          ).trim().toLowerCase();
        }

        return mediaColor;
      };

      // Selected color se matching media
      const matchedSlides = slides.filter((slide) => {
        const mediaColor = getMediaColor(slide);

        return (
          color &&
          mediaColor &&
          mediaColor.includes(color)
        );
      });

      slides.forEach((slide, i) => {
        let shouldShow = false;

        if (matchedSlides.length > 0) {
          // Selected variant/color ki sari matching media
          shouldShow = matchedSlides.includes(slide);
        } else {
          // Koi matching alt nahi → first media only
          shouldShow = i === 0;
        }

        slide.style.display = shouldShow ? '' : 'none';
        slide.style.order = shouldShow ? '1' : '3';

        if (dots[i]) {
          dots[i].style.display = shouldShow ? '' : 'none';
        }
      });

      track.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      setActive(0);
    };

  }

  // ════════════════════════════════════════════════════════
  // COLOR DRAWER
  // ════════════════════════════════════════════════════════
  function initColorDrawer() {
    const trigger = $('cpColorTrigger');
    const grid    = $('cpColorGrid');
    if (!trigger || !grid) return;

    const colors = getUniqueColors();

if (colors.length === 1) {
  selectedColor = colors[0].options[colorIdx];

  const label  = $('cpColorLabel');
  const swatch = $('cpColorSwatch');

  if (label) {
    label.textContent = selectedColor.toUpperCase();
  }

  setSwatchEl(swatch, selectedColor);
}

    if (noColorOption || !colors.length) {
      if (trigger) trigger.style.display = 'none';
      selectedVariant = PRODUCT.variants.find(v => v.available) || PRODUCT.variants[0];
      updatePriceDisplay();
      buildSizeList();
      return;
    }

    colors.forEach(variant => {
      const color  = variant.options[colorIdx];
      const imgSrc = getVariantImage(variant);
      const card   = document.createElement('button');
      card.className        = 'cp-color-card';
      card.dataset.color    = color;
      card.dataset.variantId = variant.id;
      card.innerHTML = `
        <div class="cp-color-card__img">
          <img src="${resizeImg(imgSrc, '300')}" alt="${color}" loading="lazy">
        </div>
        <p class="cp-color-card__label">${color.toUpperCase()}</p>
      `;
      card.addEventListener('click', () => selectColor(color, card));
      grid.appendChild(card);
    });

    trigger.addEventListener('click', () => {
      trigger.setAttribute('aria-expanded', 'true');
      openDrawer('cpColorDrawer');
    });

    $$('[data-close="cpColorDrawer"]').forEach(el =>
      el.addEventListener('click', () => {
        closeDrawer('cpColorDrawer');
        trigger.setAttribute('aria-expanded', 'false');
      })
    );
  }

  function selectColor(color, cardEl) {
    selectedColor = color;

    $$('.cp-color-card').forEach(c => c.classList.remove('cp-color-card--active'));
    cardEl.classList.add('cp-color-card--active');

    // Update trigger label + accurate swatch
    const label  = $('cpColorLabel');
    const swatch = $('cpColorSwatch');
    if (label)  label.textContent = color.toUpperCase();
    setSwatchEl(swatch, color);

    // Filter gallery
    if (window.cpFilterGallery) {
      window.cpFilterGallery();
    }

    // Filter mobile grid
      const colorVariantIds = PRODUCT.variants
    .filter(v => v.options[colorIdx] === color)
    .map(v => v.id);
    
    $$('.cp-mobile-grid__item').forEach(item => {
      const ids = (item.dataset.variantIds || '').split(',').filter(Boolean).map(Number);
      item.style.display = ids.some(id => colorVariantIds.includes(id)) ? '' : 'none';
    });

    // Update sticky thumb
    const thumb = document.querySelector('.cp-sticky__thumb img');
    const firstV = PRODUCT.variants.find(v => v.options[colorIdx] === color);
    if (thumb && firstV && firstV.featured_image) {
      thumb.src = resizeImg(firstV.featured_image.src, '80');
    }

    selectedVariant = null;
    buildSizeList();
    updatePriceDisplay();
    closeDrawer('cpColorDrawer');
    console.log('COLOR:', color);
  }

  // ════════════════════════════════════════════════════════
  // SIZE LIST
  // ════════════════════════════════════════════════════════
  function buildSizeList() {
    const list   = $('cpSizeList');
    const addBtn = $('cpAddToBag');
    if (!list) return;
    list.innerHTML = '';
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'ADD TO BAG'; }

    let variants = PRODUCT.variants;
    if (selectedColor && colorIdx !== -1) {
      variants = variants.filter(v => v.options[colorIdx] === selectedColor);
    }

    // One-size
    if (sizeIdx === -1) {
      const v = variants.find(v => v.available) || variants[0];
      if (!v) return;
      const btn = document.createElement('button');
      btn.className = 'cp-size-opt';
      btn.dataset.variantId = v.id;
      btn.textContent = 'US / ONE SIZE';
      btn.addEventListener('click', () => selectSize(v, btn));
      list.appendChild(btn);
      return;
    }

    const seen = new Set();
    variants.forEach(v => {
      const size = v.options[sizeIdx];
      if (seen.has(size)) return;
      seen.add(size);
      const btn = document.createElement('button');
      btn.className = 'cp-size-opt';
      btn.dataset.variantId = v.id;
      btn.textContent = 'US / ' + size.toUpperCase();
      if (!v.available) btn.disabled = true;
      btn.addEventListener('click', () => selectSize(v, btn));
      list.appendChild(btn);
    });
  }

  function selectSize(variant, btnEl) {
    if (!selectedColor && colorIdx !== -1) {
  alert('Please select a color first');
  return;
  console.log('SIZE VARIANT:', variant.id, variant.options);
}
    selectedVariant = variant;
    $$('.cp-size-opt').forEach(b => b.classList.remove('cp-size-opt--active'));
    btnEl.classList.add('cp-size-opt--active');
    const addBtn = $('cpAddToBag');
    if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'ADD TO BAG'; }
    updatePriceDisplay();
  }

  function updatePriceDisplay() {
    const formatted = moneyFormat(selectedVariant ? selectedVariant.price : PRODUCT.price);
    const priceEl     = $('cpPrice');
    const stickyPrice = $('cpStickyPrice');
    if (priceEl)     priceEl.textContent     = formatted;
    if (stickyPrice) stickyPrice.textContent = formatted;
  }

  // ════════════════════════════════════════════════════════
  // SIZE DRAWER
  // ════════════════════════════════════════════════════════
  function initSizeDrawer() {
    [$('cpSizeBtn'), $('cpStickyBtn')].filter(Boolean).forEach(btn =>
      btn.addEventListener('click', () => openDrawer('cpSizeDrawer'))
    );
    $$('[data-close="cpSizeDrawer"]').forEach(el =>
      el.addEventListener('click', () => closeDrawer('cpSizeDrawer'))
    );
    const addBtn = $('cpAddToBag');
    if (addBtn) addBtn.addEventListener('click', addToCart);
  }

  // ════════════════════════════════════════════════════════
  // ADD TO CART — closes size drawer, opens theme cart
  // ════════════════════════════════════════════════════════
  function addToCart() {
    if (!selectedVariant) return;
    const addBtn = $('cpAddToBag');
    addBtn.disabled = true;
    addBtn.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: selectedVariant.id, quantity: 1 })
    })
      .then(r => {
        if (!r.ok) return r.json().then(e => { throw new Error(e.description || 'Error adding item'); });
        return r.json();
      })
      .then(() => {
        addBtn.textContent = 'ADDED ✓';

        // ── Close size drawer first ──
        setTimeout(() => {
          addBtn.disabled   = false;
          addBtn.textContent = 'ADD TO BAG';
          closeDrawer('cpSizeDrawer');

          // ── Open theme cart drawer (try all common patterns) ──
          openThemeCart();
        }, 600);

        refreshCartCount();
      })
      .catch(err => {
        addBtn.disabled   = false;
        addBtn.textContent = (err.message || 'TRY AGAIN').toUpperCase();
        setTimeout(() => { addBtn.textContent = 'ADD TO BAG'; }, 2500);
      });
      console.log('ADDING:', selectedVariant.id, selectedVariant.options);
  }

  function openThemeCart() {
    // 1. Dispatch events most themes listen to
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('ajaxCart:open'));

    // 2. Theme-specific methods
    if (window.Shopify && window.Shopify.theme) {
      // Dawn / Debut / common OS2.0 themes
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') { cartDrawer.open(); return; }

      // Broadcast channel (newer themes)
      try {
        const bc = new BroadcastChannel('cart');
        bc.postMessage({ type: 'open' });
        bc.close();
      } catch(e) {}
    }

    // 3. Click cart icon as last resort
    const cartTriggers = [
      '[data-cart-toggle]',
      '[data-drawer-trigger="cart"]',
      '.js-cart-open',
      '.cart-toggle',
      '#cart-icon-bubble',
      '.header__icon--cart',
      '[href="/cart"]',
    ];
    for (const sel of cartTriggers) {
      const el = document.querySelector(sel);
      if (el) { el.click(); break; }
    }
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        $$('[data-cart-count],[data-cart-item-count],.cart-count,.cart__count,.js-cart-count,.cart-item-count').forEach(el => {
          el.textContent = count;
          if (count > 0) el.removeAttribute('hidden');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(() => {});
  }

  // ════════════════════════════════════════════════════════
  // ACCORDIONS
  // ════════════════════════════════════════════════════════
  function initAccordions() {
    $$('.cp-accordion__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const body = btn.nextElementSibling;
        const open = btn.getAttribute('aria-expanded') === 'true';
        $$('.cp-accordion__btn').forEach(b => {
          b.setAttribute('aria-expanded', 'false');
          if (b.nextElementSibling) b.nextElementSibling.hidden = true;
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          body.hidden = false;
        }
      });
    });
  }

  // ════════════════════════════════════════════════════════
  // SIZE CHART MODAL
  // ════════════════════════════════════════════════════════
  function initSizeChart() {
    const link  = $('cpSizeGuideLink');
    const modal = $('cpSizeChartModal');
    const closeBtn = $('cpSizeChartCloseBtn');
    const overlay  = $('cpSizeChartClose'); // overlay div has same ID as close was, now separate
    if (!link || !modal) return;

    link.addEventListener('click', e => {
      e.preventDefault();
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    function closeSizeChart() {
      modal.setAttribute('aria-hidden', 'true');
      if ($('cpSizeDrawer') && $('cpSizeDrawer').getAttribute('aria-hidden') === 'false') {
        // size drawer still open, keep body locked
      } else {
        document.body.style.overflow = '';
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', closeSizeChart);
    if (overlay)  overlay.addEventListener('click',  closeSizeChart);
  }

  // ════════════════════════════════════════════════════════
  // ESC KEY
  // ════════════════════════════════════════════════════════
  function initCloseHandlers() {
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      $$('.cp-drawer[aria-hidden="false"]').forEach(d => closeDrawer(d.id));
      const modal = $('cpSizeChartModal');
      if (modal && modal.getAttribute('aria-hidden') === 'false') {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  // ════════════════════════════════════════════════════════
  // STICKY BAR
  // ════════════════════════════════════════════════════════
  function initStickyBar() {
    const bar    = $('cpSticky');
    const anchor = $('cpSizeBtn');
    if (!bar || !anchor) return;
    const obs = new IntersectionObserver(([e]) => {
      bar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
    }, { threshold: 0 });
    obs.observe(anchor);
  }

  // ════════════════════════════════════════════════════════
  // SHIPPING ESTIMATE
  // Real rates from Shopify + IP geolocation
  // ════════════════════════════════════════════════════════
  function initShipping() {
    const container  = $('cpShippingEstimates');
    const zipBtn     = $('cpZipBtn');
    const zipDisplay = $('cpZipDisplay');
    if (!container) return;

    // Country codes from IP data → Shopify country name
    const COUNTRY_NAMES = {
      US:'United States',GB:'United Kingdom',CA:'Canada',AU:'Australia',
      DE:'Germany',FR:'France',IT:'Italy',ES:'Spain',NL:'Netherlands',
      PK:'Pakistan',IN:'India',BD:'Bangladesh',AE:'United Arab Emirates',
      SA:'Saudi Arabia',TR:'Turkey',PL:'Poland',SE:'Sweden',NO:'Norway',
      DK:'Denmark',CH:'Switzerland',AT:'Austria',BE:'Belgium',MX:'Mexico',
      BR:'Brazil',JP:'Japan',KR:'South Korea',SG:'Singapore',MY:'Malaysia',
      NZ:'New Zealand',ZA:'South Africa',NG:'Nigeria',KE:'Kenya',EG:'Egypt',
      AR:'Argentina',CL:'Chile',CO:'Colombia',PH:'Philippines',ID:'Indonesia',
      TH:'Thailand',VN:'Vietnam',HK:'Hong Kong',TW:'Taiwan',
    };

    function fetchRates(zip, countryCode, province) {
      if (!zip && !countryCode) {
        container.innerHTML = '<p>Click your location above to see shipping options.</p>';
        return;
      }

      const country  = COUNTRY_NAMES[countryCode] || countryCode || 'United States';
      const prov     = province || '';
      const url      = `/cart/shipping_rates.json?shipping_address[zip]=${encodeURIComponent(zip || '')}&shipping_address[country]=${encodeURIComponent(country)}&shipping_address[province]=${encodeURIComponent(prov)}`;

      container.innerHTML = '<p class="cp-shipping__loading">Fetching shipping options...</p>';

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.json())
        .then(data => {
          const rates = data.shipping_rates;
          if (!rates || !rates.length) {
            container.innerHTML = '<p>No shipping rates available for this location.</p>';
            return;
          }
          container.innerHTML = rates.slice(0, 5).map(r => {
            const price = parseFloat(r.price) === 0 ? 'FREE' : '$ ' + parseFloat(r.price).toFixed(2);
            return `<p>${r.name.toUpperCase()}: ${price}</p>`;
          }).join('');
        })
        .catch(() => {
          container.innerHTML = '<p>Could not fetch shipping rates. See checkout for options.</p>';
        });
    }

    // ── Auto-detect via IP ───────────────────────────────
    function autoDetect() {
      // Try ipapi.co — returns country, region, postal, city
      fetch('https://ipapi.co/json/', { cache: 'default' })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(data => {
          const zip     = data.postal    || '';
          const country = data.country_code || 'US';
          const prov    = data.region_code  || '';
          const city    = data.city || '';
          const display = zip ? zip : (city || country);

          zipDisplay.textContent = display;
          sessionStorage.setItem('cp_zip',     zip);
          sessionStorage.setItem('cp_country', country);
          sessionStorage.setItem('cp_province',prov);

          fetchRates(zip, country, prov);
        })
        .catch(() => {
          // Fallback: try ip-api.com (no HTTPS on free plan but we try)
          fetch('https://ip-api.com/json/?fields=countryCode,regionName,zip,city', { cache: 'default' })
            .then(r => r.json())
            .then(data => {
              const zip     = data.zip     || '';
              const country = data.countryCode || 'US';
              const prov    = data.regionName  || '';
              const city    = data.city || '';
              const display = zip ? zip : (city || country);

              zipDisplay.textContent = display;
              sessionStorage.setItem('cp_zip',     zip);
              sessionStorage.setItem('cp_country', country);
              sessionStorage.setItem('cp_province',prov);

              fetchRates(zip, country, prov);
            })
            .catch(() => {
              container.innerHTML = '<p>Click location above to enter your ZIP for shipping options.</p>';
            });
        });
    }



    // ── Check session cache ──────────────────────────────
    const cachedZip     = sessionStorage.getItem('cp_zip');
    const cachedCountry = sessionStorage.getItem('cp_country');
    const cachedProv    = sessionStorage.getItem('cp_province');

    if (cachedCountry) {
      zipDisplay.textContent = cachedZip || cachedCountry;
      fetchRates(cachedZip || '', cachedCountry, cachedProv || '');
    } else {
      zipDisplay.textContent = 'DETECTING...';
      container.innerHTML = '<p class="cp-shipping__loading">Detecting your location...</p>';
      autoDetect();
    }
  }

  // ════════════════════════════════════════════════════════
  // INIT
  // ════════════════════════════════════════════════════════
  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initAccordions();
    initColorDrawer();
    buildSizeList();
    initSizeDrawer();
    initSizeChart();
    initCloseHandlers();
    initStickyBar();
    initShipping();
    updatePriceDisplay();

    // Filter gallery for first available color on page load
    const firstVariant = PRODUCT.variants.find(v => v.available) || PRODUCT.variants[0];

    if (firstVariant && colorIdx !== -1 && window.cpFilterGallery) {
      selectedColor = firstVariant.options[colorIdx];
      window.cpFilterGallery();
    }

    // ── Pre-select color/variant from URL ?variant=ID ──
    var urlParams  = new URLSearchParams(window.location.search);
    var urlVarId   = urlParams.get('variant');
    if (urlVarId && colorIdx !== -1) {
      var urlVariant = PRODUCT.variants.find(function(v) {
        return String(v.id) === String(urlVarId);
      });
      if (urlVariant) {
        var color = urlVariant.options[colorIdx];
        var card  = document.querySelector('.cp-color-card[data-color="' + color + '"]');
        if (card) {
          selectColor(color, card);
        } else {
          // Card not found by exact match, try case-insensitive
          document.querySelectorAll('.cp-color-card').forEach(function(c) {
            if ((c.dataset.color || '').toLowerCase() === color.toLowerCase()) {
              selectColor(color, c);
            }
          });
        }
      }
    }
  });

})();
